"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MultiSlider = require("./MultiSlider");

var _MultiSlider2 = _interopRequireDefault(_MultiSlider);

var _uncontrollable = require("uncontrollable");

var _uncontrollable2 = _interopRequireDefault(_uncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _uncontrollable2.default)(_MultiSlider2.default, { values: "onChange" });
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/multi-slider/lib/index.js
 ** module id = 177
 ** module chunks = 0
 **/